import { z } from 'zod';

import type { Translate } from '@src/i18n/useTranslate';

export const emailSchema = (t: Translate['i18n']) => {
  const invalidEmailMessage = t('checkout_auth_invalid_email');

  return z.object({
    email: z.union([z.literal(''), z.string().email({ message: invalidEmailMessage })]),
  });
};

export type EmailFormValues = z.infer<ReturnType<typeof emailSchema>>;
